import React from 'react';
import CanvasPreview from './CanvasPreview';
import LayersList from './LayersList';
import LayerEditor from './LayerEditor';
import GroupsManager from './GroupsManager';

export default function PreviewWithTools({ 
  canvas, 
  selectedId, 
  setSelectedId, 
  updateLayer, 
  deleteLayer, 
  bringToFront,
  addLayer,
  fileLayerImgRef,
  fileLayerVideoRef,
  fileLayerGifRef,
  fileLayerAudioRef,
  fileTextBgImgRef,
  fileTextBgVideoRef,
  handleUpload,
  lockedLayers,
  toggleLockLayer,
  showAllLayers,
  hideAllLayers,
  addGroup,
  deleteGroup,
  addLayerToGroup,
  removeLayerFromGroup,
  toggleGroupVisibility,
  updateGroupName
}) {
  return (
    <div className="preview-with-tools" style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      height: '100%',
      minHeight: 0
    }}>
      {/* معاينة الكنفا */}
      <div className="canvas-preview-section" style={{
        background: 'var(--bg-secondary)',
        borderRadius: '15px',
        padding: '20px',
        boxShadow: '0 4px 15px var(--shadow-color)',
        border: '1px solid var(--border-color)',
        minHeight: '300px',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <h3 style={{
          margin: '0 0 15px 0',
          color: 'var(--text-primary)',
          fontSize: '16px',
          fontWeight: 'bold',
          textAlign: 'center'
        }}>
          🎨 معاينة الكنفا
        </h3>
        
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CanvasPreview 
            canvas={canvas} 
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            updateLayer={updateLayer}
          />
        </div>
      </div>

      {/* أزرار إضافة العناصر */}
      <div className="add-layer-buttons" style={{
        background: 'var(--bg-secondary)',
        borderRadius: '15px',
        padding: '20px',
        boxShadow: '0 4px 15px var(--shadow-color)',
        border: '1px solid var(--border-color)'
      }}>
        <h3 style={{
          margin: '0 0 15px 0',
          color: 'var(--text-primary)',
          fontSize: '16px',
          fontWeight: 'bold',
          textAlign: 'center'
        }}>
          ➕ إضافة عناصر جديدة
        </h3>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
          gap: '10px',
          justifyContent: 'center'
        }}>
          <button onClick={() => addLayer('text')} style={{
            background: 'var(--button-bg)',
            color: '#fff',
            borderRadius: '8px',
            border: 'none',
            padding: '10px 16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px'
          }}>
            <span>📝</span>
            <span>إضافة نص</span>
          </button>
          
          <button onClick={() => fileLayerImgRef.current?.click()} style={{
            background: 'var(--button-bg)',
            color: '#fff',
            borderRadius: '8px',
            border: 'none',
            padding: '10px 16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px'
          }}>
            <span>🖼️</span>
            <span>إضافة صورة</span>
          </button>
          <input type="file" accept="image/*" ref={fileLayerImgRef} style={{display:'none'}} onChange={e => handleUpload(e, 'layerImg')} />
          
          <button onClick={() => fileLayerVideoRef.current?.click()} style={{
            background: 'var(--button-bg)',
            color: '#fff',
            borderRadius: '8px',
            border: 'none',
            padding: '10px 16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px'
          }}>
            <span>🎥</span>
            <span>إضافة فيديو</span>
          </button>
          <input type="file" accept="video/*" ref={fileLayerVideoRef} style={{display:'none'}} onChange={e => handleUpload(e, 'layerVideo')} />
          
          <button onClick={() => fileLayerGifRef.current?.click()} style={{
            background: 'var(--button-bg)',
            color: '#fff',
            borderRadius: '8px',
            border: 'none',
            padding: '10px 16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px'
          }}>
            <span>🎬</span>
            <span>إضافة GIF</span>
          </button>
          <input type="file" accept="image/gif" ref={fileLayerGifRef} style={{display:'none'}} onChange={e => handleUpload(e, 'layerGif')} />
          
          <button onClick={() => fileLayerAudioRef.current?.click()} style={{
            background: 'var(--button-bg)',
            color: '#fff',
            borderRadius: '8px',
            border: 'none',
            padding: '10px 16px',
            fontWeight: 'bold',
            cursor: 'pointer',
            fontSize: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px'
          }}>
            <span>🔊</span>
            <span>إضافة صوت</span>
          </button>
          <input type="file" accept="audio/*" ref={fileLayerAudioRef} style={{display:'none'}} onChange={e => handleUpload(e, 'layerAudio')} />
          
          {/* عناصر رفع ملفات خلفية النص */}
          <input type="file" accept="image/*" ref={fileTextBgImgRef} style={{display:'none'}} onChange={e => handleUpload(e, 'textBgImage')} />
          <input type="file" accept="video/*" ref={fileTextBgVideoRef} style={{display:'none'}} onChange={e => handleUpload(e, 'textBgVideo')} />
        </div>
      </div>

      {/* أدوات الطبقات */}
      <div className="layers-tools-section" style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        alignItems: 'stretch',
        flex: 1,
        minHeight: 0
      }}>
        {/* إدارة المجموعات */}
        <GroupsManager
          canvas={canvas}
          addGroup={addGroup}
          deleteGroup={deleteGroup}
          addLayerToGroup={addLayerToGroup}
          removeLayerFromGroup={removeLayerFromGroup}
          toggleGroupVisibility={toggleGroupVisibility}
          updateGroupName={updateGroupName}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
        />
        
        {/* أزرار إظهار/إخفاء الكل */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginBottom: '5px' }}>
          <button onClick={showAllLayers} style={{ background: 'var(--button-bg)', color: '#fff', border: 'none', borderRadius: '6px', padding: '6px 14px', fontWeight: 'bold', cursor: 'pointer' }}>👁️ إظهار الكل</button>
          <button onClick={hideAllLayers} style={{ background: 'var(--bg-secondary)', color: 'var(--text-primary)', border: '1px solid var(--border-color)', borderRadius: '6px', padding: '6px 14px', fontWeight: 'bold', cursor: 'pointer' }}>🚫 إخفاء الكل</button>
        </div>
        {/* قائمة الطبقات */}
        <div className="layers-list-section" style={{
          background: 'var(--bg-secondary)',
          borderRadius: '15px',
          padding: '20px',
          boxShadow: '0 4px 15px var(--shadow-color)',
          border: '1px solid var(--border-color)',
          height: '100%',
          minHeight: 0,
          overflowY: 'auto',
          flex: 1
        }}>
          <h3 style={{
            margin: '0 0 15px 0',
            color: 'var(--text-primary)',
            fontSize: '16px',
            fontWeight: 'bold',
            textAlign: 'center'
          }}>
            📋 قائمة الطبقات
          </h3>
          
          <LayersList
            layers={canvas.layers}
            selectedId={selectedId}
            setSelectedId={setSelectedId}
            deleteLayer={deleteLayer}
            bringToFront={bringToFront}
            lockedLayers={lockedLayers}
            toggleLockLayer={toggleLockLayer}
            canvas={canvas}
          />
        </div>

        {/* محرر الطبقة */}
        {selectedId && (
          <div className="layer-editor-section" style={{
            background: 'var(--bg-secondary)',
            borderRadius: '15px',
            padding: '20px',
            boxShadow: '0 4px 15px var(--shadow-color)',
            border: '1px solid var(--border-color)',
            overflowY: 'auto',
            minHeight: 0,
            marginTop: '10px'
          }}>
            <h3 style={{
              margin: '0 0 15px 0',
              color: 'var(--text-primary)',
              fontSize: '16px',
              fontWeight: 'bold',
              textAlign: 'center'
            }}>
              ⚙️ محرر الطبقة
            </h3>
            
            <LayerEditor
              layer={canvas.layers.find(l => l.id === selectedId)}
              updateLayer={updateLayer}
              deleteLayer={deleteLayer}
              canvas={canvas}
              handleUpload={handleUpload}
              fileTextBgImgRef={fileTextBgImgRef}
              fileTextBgVideoRef={fileTextBgVideoRef}
            />
          </div>
        )}
      </div>

      {/* CSS للاستجابة */}
      <style jsx>{`
        @media (max-width: 768px) {
          .layers-tools-section {
            grid-template-columns: 1fr !important;
            gap: 15px !important;
          }
          
          .canvas-preview-section {
            min-height: 300px !important;
            padding: 15px !important;
          }
          
          .layers-list-section,
          .layer-editor-section {
            max-height: 250px !important;
            padding: 15px !important;
          }
          
          .add-layer-buttons > div {
            grid-template-columns: repeat(auto-fit, minmax(120px, 1fr)) !important;
            gap: 8px !important;
          }
          
          .add-layer-buttons button {
            padding: 8px 12px !important;
            font-size: 12px !important;
          }
          
          .add-layer-buttons button span:last-child {
            display: none !important;
          }
        }
        
        @media (max-width: 480px) {
          .layers-tools-section {
            gap: 10px !important;
          }
          
          .canvas-preview-section {
            min-height: 250px !important;
            padding: 10px !important;
          }
          
          .layers-list-section,
          .layer-editor-section {
            max-height: 200px !important;
            padding: 10px !important;
          }
          
          .add-layer-buttons > div {
            grid-template-columns: 1fr !important;
          }
          
          .add-layer-buttons button span:last-child {
            display: inline !important;
          }
        }
      `}</style>
    </div>
  );
} 